import { NavLink } from 'react-router-dom'
import {
  Building2, Users, BarChart2, History, Mic,
  UserCircle, UserCheck, LogOut,
} from 'lucide-react'
import { useAuthStore } from '../../store/auth'
import { authApi } from '../../api/auth'
import { cn, fullName } from '../../lib/utils'

const NAV = [
  { to: 'companies', label: 'Companies', icon: Building2 },
  { to: 'users', label: 'Users', icon: Users },
  { to: 'stats', label: 'Stats', icon: BarChart2 },
  { to: 'logs', label: 'Logs', icon: History },
  { to: 'recordings', label: 'Recordings', icon: Mic },
]

export function AdminSidebar() {
  const { user, clearAuth } = useAuthStore()
  const homepageUrl = import.meta.env.FRONTEND_URL || window.location.origin

  const handleLogout = async () => {
    await authApi.logout().catch(() => {})
    clearAuth()
  }

  return (
    <div className="w-56 flex-shrink-0 bg-white border-r border-gray-200 flex flex-col h-full">
      <div className="px-4 py-4 border-b border-gray-200">
        <a href={homepageUrl} className="flex items-center gap-2 hover:opacity-90 transition-opacity">
          <div className="w-7 h-7 rounded bg-primary-600 flex items-center justify-center">
            <UserCheck className="w-4 h-4 text-white" />
          </div>
          <span className="font-semibold text-gray-900 text-sm">CRM Admin</span>
        </a>
      </div>

      <nav className="flex-1 overflow-y-auto py-3 px-2 space-y-0.5">
        {NAV.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={`/admin/${to}`}
            className={({ isActive }) => cn('sidebar-link', isActive && 'active')}
          >
            <Icon className="w-4 h-4" />
            {label}
          </NavLink>
        ))}

        <div className="my-2 border-t border-gray-200" />

        <NavLink
          to="/admin/profile"
          className={({ isActive }) => cn('sidebar-link', isActive && 'active')}
        >
          <UserCircle className="w-4 h-4" />
          Profile
        </NavLink>
      </nav>

      <div className="px-2 py-3 border-t border-gray-200">
        <div className="flex items-center gap-2 px-2 py-1 mb-1">
          <div className="w-7 h-7 rounded-full bg-primary-100 flex items-center justify-center text-primary-700 text-xs font-semibold">
            {user?.firstName?.[0]}{user?.lastName?.[0]}
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs font-medium text-gray-900 truncate">{fullName(user?.firstName, user?.lastName)}</p>
            <p className="text-xs text-gray-500 truncate">{user?.role}</p>
          </div>
        </div>
        <button onClick={handleLogout} className="sidebar-link w-full text-red-600 hover:bg-red-50 hover:text-red-700">
          <LogOut className="w-4 h-4" />
          Sign out
        </button>
      </div>
    </div>
  )
}
